export const qr = {
  seo: {
    title: 'Commande QR sur place pour restaurants | Bistroo',
    description: "Laissez les clients commander et payer de façon autonome via QR code. Moins de personnel, panier moyen plus élevé. Essayez gratuitement pendant 30 jours.",
  },
  hero: {
    title: {
      pt1: 'Une',
      pt2: 'solution QR',
      pt3: 'sur mesure pour votre restaurant',
    },
    description:
      'Permettez un processus de commande à table rentable, soulagez vos employés et améliorez l\'expérience de vos clients du premier scan jusqu\'au paiement.',
    button: 'Découvrir la solution QR',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Simplifiez la commande, maximisez la satisfaction client',
      text: 'Donnez à vos clients la liberté de commander ce qu\'ils veulent, quand ils le veulent. Optimisez le service, augmentez la commodité et améliorez l\'expérience client à chaque scan.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_2: {
      title: 'Mettez facilement à jour votre boutique QR',
      text: 'Toutes les mises à jour dans le Bistroo Manager sont immédiatement synchronisées avec les autocollants QR sur vos tables, ce qui rend la modification du menu plus rapide et plus facile que jamais.',
      cta: '',
    },
    paragraph_3: {
      title: 'Votre style, vos autocollants',
      text: 'Les autocollants sont de haute qualité et personnalisés dans votre style et votre image de marque. Ils sont fabriqués dans un matériau durable et résistant aux intempéries, ce qui les rend adaptés à une utilisation aussi bien en intérieur qu\'en extérieur.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_4: {
      title: 'Administration facile',
      text: 'Des paiements aux factures, tout est entièrement automatisé. Les commandes sont traitées, les paiements peuvent être suivis et les factures sont générées automatiquement, ce qui réduit considérablement votre charge de travail.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Faites de l\'upselling une partie intégrante de votre activité',
        text: 'Utilisez les options d\'upsell intelligentes et faites-en une partie naturelle de chaque commande sur place, ce qui permet d\'augmenter le chiffre d\'affaires sans effort.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Intégrations',
        text: 'Connectez votre système de caisse ou vos outils externes préférés.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Résolvez les défis en matière de personnel',
        text: 'Lorsqu\'un défi se présente, résolvez-le facilement avec les commandes QR à table.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Paiements instantanés',
        text: 'Fini les paiements au comptoir, les clients paient lors de la commande.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Remises et fidélité',
        text: 'Encouragez les clients à utiliser la solution QR en profitant de nos options de remises et de fidélité.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Une collaboration agréable et un partenaire disponible 24h/24 et 7j/7."',
    cta: 'Lire l\'histoire complète',
    name: 'De Wethouder',
    job_title: 'Sushi & Drink Club',
  },
  faq: {
    title_pt1: 'Tout sur la',
    title_pt2: 'solution QR Bistroo',
    items: [
      { q: 'Comment fonctionne la commande QR pour mes clients ?', a: 'Les clients scannent l\'autocollant QR sur la table avec leur téléphone, voient directement le menu et commandent et paient de façon autonome. Pas d\'application nécessaire, pas d\'attente au comptoir.' },
      { q: 'Comment créer des autocollants QR ?', a: 'Après activation du module QR dans votre compte Bistroo, vous générez des autocollants personnalisés à votre charte graphique. Bistroo les imprime pour vous sur un matériau durable et résistant aux intempéries.' },
      { q: 'Les clients peuvent-ils payer directement via le QR code ?', a: 'Oui. Les clients paient directement lors de la commande via iDEAL, carte de crédit, Apple Pay ou Google Pay. Fini les paiements au comptoir et les attentes pour l\'addition.' },
      { q: 'Le menu est-il automatiquement synchronisé ?', a: 'Oui. Toutes les modifications apportées dans le Bistroo Manager sont immédiatement visibles dans la boutique QR. Vous n\'avez jamais besoin de mettre à jour votre menu à deux endroits.' },
      { q: 'Comment traiter les commandes QR en cuisine ?', a: 'Les commandes QR arrivent de la même façon que toutes les autres commandes Bistroo : directement sur le Bistroo Device, l\'imprimante cuisine ou le système de caisse. Aucun écran ou action supplémentaire nécessaire.' },
      { q: 'Les autocollants QR sont-ils adaptés à une utilisation en extérieur ?', a: 'Oui. Les autocollants sont fabriqués dans un matériau résistant aux intempéries et conviennent à une utilisation en intérieur comme en extérieur, même sur les terrasses sous la pluie ou le soleil.' },
      { q: 'Puis-je créer des QR codes séparés par table ou par zone ?', a: 'Oui. Vous créez des QR codes séparés par table, par salle ou par terrasse. Ainsi, votre cuisine sait toujours exactement de quelle table provient une commande.' },
      { q: 'Comment configurer l\'upselling pour les commandes QR ?', a: 'Via le Bistroo Manager, vous activez des suggestions d\'upsell automatiques. Lors de la commande, le client se voit proposer des extras ou des combinaisons adaptés, ce qui augmente la valeur moyenne des commandes.' },
      { q: 'Quel est le coût de la solution QR ?', a: 'Le module QR fait partie des formules Bistroo. Selon votre formule, il n\'y a pas ou peu de frais supplémentaires. Consultez la page des tarifs pour un aperçu actualisé.' },
      { q: 'Comment recevoir des notifications pour les nouvelles commandes QR ?', a: 'Les nouvelles commandes apparaissent directement sur le Bistroo Device, l\'application Manager et les éventuelles imprimantes connectées. Vous recevez également une notification push sur l\'application Bistroo afin de ne jamais manquer une commande.' },
    ],
  },
}
